import Http from '../../../../network/Http';
import {NatGetBillingAmountFixInfo} from './NatGetBillingAmountFixInfo';
import {NatGetResidentBillingAmountLatest} from './NatGetResidentBillingAmountLatest'
import {NatGetResidentBillingAmountDetail} from './NatGetResidentBillingAmountDetail'
import {ApiResponse} from '../../../../network/response/ApiResponse'
import {
    NatPutBillingAmountFixAlreadyViewRequest,
    NatPutBillingAmountFixAlreadyViewResponse
} from './NatPutBillingAmountFixAlreadyView'
import {ContentType} from '../../../../network/Constants'
import {NatGetReceiptIssuePrevInputInfo, NatPutReceiptIssueRequest} from './NatGetReceiptIssuePrevInputInfo'
import {SessionStorageHelper} from '../../../../SessionStorageHelper'
import {
    ResidentLoginInfoSessionStorageKey
} from '../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {LOGIN_MODE} from '../../../../CodeMaster'
import {NatBaseResponseInterface} from '../../common/repository/NatBaseResponseInterface'

export default class NatAmountFixRepo {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    // 請求額確定情報取得
    async getBillingAmountFixInfo(
        condominiumCd: string,
        ridgeCd: string,
        roomNumber: string,
        seq: number
    ): Promise<NatGetBillingAmountFixInfo> {
        return await this.http.get(`/api/resident/condominiums/${condominiumCd}/ridges/${ridgeCd}` +
            `/rooms/${roomNumber}/user/${seq}/billing-amount/fix`)
    }

    // 請求額閲覧状況登録
    async postBillingAmountFixAlreadyView(
        request: NatPutBillingAmountFixAlreadyViewRequest
    ): Promise<NatPutBillingAmountFixAlreadyViewResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${request.condominiumCd}/ridges/${request.ridgeCd}/rooms/${request.roomNumber}/user/${request.seq}/billing-amount/fix/already-view`,
            {},
            ContentType.JSON,
        )
    }

    // 請求年月一覧取得
    async getBillingYearMonthList(
        condominiumCd: string,
        ridgeCd: string,
        roomNumber: string
    ): Promise<ApiResponse<any[]>> {
        if (SessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.LOGIN_MODE) === LOGIN_MODE.RESIDENT.value) {
            return await this.http.get(`/api/resident/condominiums/${condominiumCd}/ridges/${ridgeCd}/rooms/${roomNumber}/billing-amount/billingYearMonthList`);
        }

        return {
            details: ['ー年ー月'],
            informations: []
        }
    }

    // 最新請求金額取得
    async getBillingAmountLatest(
        condominiumCd: string,
        ridgeCd: string,
        roomNumber: string
    ): Promise<NatGetResidentBillingAmountLatest> {
        if (SessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.LOGIN_MODE) === LOGIN_MODE.RESIDENT.value) {
            return await this.http.get(`/api/resident/condominiums/${condominiumCd}/ridges/${ridgeCd}/rooms/${roomNumber}/billing-amount/latest`);
        }

        return {
            details: {
                billingAmount: 'ー',
                billingAmountFixedDate: 'ー年ー月ー日',
                directDebitDate: 'ー年ー月ー日',
            },
            informations: null,
            requestError: null,
            requestItemErrors: null
        }
    }

    // 取引金額取得
    async getBillingAmountDetail(
        condominiumCd: string,
        ridgeCd: string,
        roomNumber: string,
        billingYearMonth: string
    ): Promise<NatGetResidentBillingAmountDetail> {
        if (SessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.LOGIN_MODE) === LOGIN_MODE.RESIDENT.value) {
            return await this.http.get(`/api/resident/condominiums/${condominiumCd}/ridges/${ridgeCd}/rooms/${roomNumber}/billing-amount/trading/${billingYearMonth}`);
        }

        return {
            details: {
                billingAmount: 'ー',
                variableTrading: [{
                    expenseItemName: 'ー',
                    summaryCode: 'ー',
                    accountingYearMonth: 'ー年ー月',
                    amount: 'ー'
                }],
                variableBreakdown: [{
                    breakdownName: '内訳　ー',
                    variableBreakdownDetail: [{
                        expenseItemName: 'ー',
                        value: 'ー'
                    }]
                }],
                receiptIssueStatus: '0',
                paymentStatus: '1'
            },
            informations: null,
            requestError: null,
            requestItemErrors: null
        }
    }

    // 領収書発行（前回分）取得
    async getReceiptIssuePrevInput(
        condominiumCd: string,
        ridgeCd: string,
        roomNumber: string,
        seq: number
    ): Promise<NatGetReceiptIssuePrevInputInfo> {
        return await this.http.get(`/api/resident/condominiums/${condominiumCd}/ridges/${ridgeCd}/rooms/${roomNumber}/receipt/user/${seq}/prevInput`)
    }

    // 領収書発行（事前処理）
    async postIssueReceiptPreProcessing(
        request: NatPutReceiptIssueRequest
    ): Promise<NatBaseResponseInterface> {
        return await this.http.post(
            `/api/resident/condominiums/${request.condominiumCd}/ridges/${request.ridgeCd}/rooms/${request.roomNumber}/receipt/user/${request.seq}`,
            {
                issueTargetYearMonth: request.issueTargetYearMonth,
                destination: request.destination,
                honorific: request.honorific,
                proviso: request.proviso,
                provisoAllSelectFlag: request.provisoAllSelectFlag
            },
            ContentType.JSON,
        )
    }
}
